/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEssBaseDimension = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m13 4.807 6.291 4.051a1 1 0 0 1 .459.841v6.443l2.835 2.048-1.17 1.62-2.698-1.947-6.176 3.978a1 1 0 0 1-1.082 0l-6.177-3.978-2.697 1.947-1.17-1.62 2.835-2.048V9.699a1 1 0 0 1 .459-.84L11 4.806V2h2zm-6.75 11.3L11 19.166v-4.575l-4.75-3.059zM13 14.591v4.575l4.75-3.059v-4.575zM7.097 9.699 12 12.856 16.902 9.7 12 6.541z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgEssBaseDimension as EssBaseDimension };
